// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"d4ea6250","744":"415687ad","868":"54c7226b"}[chunkId] + ".chunk.js";
};